module.exports = __webpack_public_path__ + "static/media/wom-mas-400-gigas-tactico.78503ecc.svg";